export default __webpack_public_path__ + "static/media/ddsu5168_4p_wireless_4g.389e9726.png";